import { Injectable } from '@angular/core';

@Injectable()
export class GeoStatus {
    Success:boolean = false;                // e.g. true
    SuppressError:boolean = false;          // e.g. true -- when we get a timeout which may be due to mobile user not moving much...
    IsEnabled:boolean = false;          // e.g. is the GPS or IPS capability supported
    ActiveWatch:boolean = false;        // e.g. is the watch still going?
    WatchType:string = "";              // e.g. did this result come from WATCH or CURRENT

    ResultCode:string = "INIT";              // e.g. "OK"
    ResultText:string = "Constructor";              // e.g. "INDOOR WATCHING"
    //ErrorCode:number;               // e.g. the error.code from position result
    //GeolocationStatus:string = "Constructor";       // e.g. "(OK) INDOOR WATCHING"
    ResultTimestampEpoch:number = 0;    // e.g. moment().unix() * 1000
    ResultTimestamp:string = "";         // e.g. moment().format("YYYY-MM-DDTHH:mm:ss"); // "DT-L";
    ResultTimestampUtc:string = "";      // e.g. moment().utc().format("YYYY-MM-DDTHH:mm:ss") + "Z"; // "DT-Z";  
    PositionCount:number = 0;           // e.g. 0,1,2,3...;
    PositionType:string = "";            // e.g. "IPS" | "GPS"
}

@Injectable()
export class GeoPosition {
    GeoStatus:GeoStatus = new GeoStatus();

    Success:boolean = false;                // e.g. true
    //ActiveWatch:boolean = false;        // e.g. is the watch still going?
    //WatchType:string = "";              // e.g. did this result come from WATCH or CURRENT

    //ResultCode:string = "";              // e.g. "OK"
    //ResultText:string = "";              // e.g. "INDOOR WATCHING"
    
    //GeolocationStatus:string = "";       // e.g. "(OK) INDOOR WATCHING"
    //ResultTimestampEpoch:number = 0;    // e.g. moment().unix() * 1000
    //ResultTimestamp:string = "";         // e.g. moment().format("YYYY-MM-DDTHH:mm:ss"); // "DT-L";
    //ResultTimestampUtc:string = "";      // e.g. moment().utc().format("YYYY-MM-DDTHH:mm:ss") + "Z"; // "DT-Z";  
    PositionCount:number = 0;           // e.g. 0,1,2,3...;
    PositionType:string = "";            // e.g. "IPS" | "GPS"

    MobileTimestamp:string = "";         // e.g. moment().format("YYYY-MM-DDTHH:mm:ss"); // "DT-L";
    MobileTimestampUtc:string = "";      // e.g. moment().utc().format("YYYY-MM-DDTHH:mm:ss") + "Z"; // "DT-Z";  

    // standard position attributes
    coords:string = "";                  // e.g. position.coords;
    Latitude:string = "";                // e.g. position.coords.latitude;
    Longitude:string = "";               // e.g. position.coords.longitude;
    CoordsDisplay:string = "";           // e.g. specically formatted for display only: -34.397123,150.644321
    //LatLng:string;                  // e.g.    {lat: -34.397, lng: 150.644}
    Altitude:string = "";                // e.g. position.coords.altitude;
    Accuracy:string = "";                // e.g. position.coords.accuracy;
    Heading:string = "";                 // e.g. position.coords.heading;
    Timestamp:number = 0;               // e.g. position.timestamp; moment().unix() * 1000; // assumed to be epoch
    timestamp:number = 0;               // e.g. moment().unix() * 1000; // assumed to be epoch
    GpsTimestamp:string = "";           // normalized date format of Epoch position.timestamp // "YYYY-MM-DDTHH:mm:ss"

    // indoor only position attributes
    Floor:number = null ; // -9999;                   // e.g. position.coords.floor;
}

/*
Location accuracy
Google Maps assigns additional location accuracy values to each location mapped and defines these values as such:

"ROOFTOP" indicates that the returned result is a precise geocode for which we have location information accurate down to street address precision.
"RANGE_INTERPOLATED" indicates that the returned result reflects an approximation (usually on a road) interpolated between two precise points (such as intersections). Interpolated results are generally returned when rooftop geocodes are unavailable for a street address.
"GEOMETRIC_CENTER" indicates that the returned result is the geometric center of a result such as a polyline (for example, a street) or polygon (region).
"APPROXIMATE" indicates that the returned result is approximate.
For addresses that Google Maps is not able to map (whether for a lack of location data or inaccurate location data), Maptive separates out this data for quick export back to a spreadsheet for correction.
*/
